import { CreditModalSource, PricingModalOrigin } from '@wegic/price-ui';
import { Message } from '@wegic/ui';
import '@wegic/ui/dist/components/Message/index.css';
import { openCreditPurchaseModal } from '@/components/GlobalCreditPurchaseModal/helper';
import { getLaunchOrderPostLoginAction } from '@/components/Markdown/MarkdownViewer/CustomTagCom/GenStartButton/helper';
import { isContinueGenerationInputContent } from '@/helpers/continueGeneration';
import { markFirstGenerationContinuation } from '@/helpers/firstGenerationEntry';
import { buildContinueGenerationAutoInput, buildGenerationReference } from '@/helpers/generationReferenceImage';
import { openPricingModal } from '@/helpers/pricingModal';
import { getProjectIdFromUrl } from '@/modules/CustomRouter/handler';
import { queryUserNotify } from '@/services/user';
import { UserNotify } from '@/services/user/const';
import { useAutoInputStore } from '@/stores/autoInput';
import { ProjectStatus, useProjectStore } from '@/stores/project';
import { useUserStore } from '@/stores/user';
import { useUserNotifyStore } from '@/stores/userNotify';
export function continueLaunchOrderGeneration(order, projectId) {
    const pendingAutoInput = useAutoInputStore.getState().content;
    if (isContinueGenerationInputContent(pendingAutoInput)) {
        return;
    }
    const continueLabel = intl.get('common.continue.generating');
    const autoInput = buildContinueGenerationAutoInput(continueLabel, order, projectId);
    if (order && projectId) {
        const reference = buildGenerationReference(order);
        markFirstGenerationContinuation(projectId, 'style', reference);
    }
    useAutoInputStore.getState().setContent(autoInput.content, autoInput.files, autoInput.displayContent, projectId);
}
export function openLaunchOrderUpgradeModal() {
    collect('upgrade_button_click', {
        source: 'project_launch_order'
    });
    openPricingModal({
        origin: PricingModalOrigin.ChatGenStartButton
    });
}
export async function resolveHasPaidTrialPack() {
    try {
        const response = await queryUserNotify(UserNotify.TrafficPackage);
        const hasPaidTrialPack = response.data.needNotified === false;
        useUserNotifyStore.getState().updateNotifyState(UserNotify.TrafficPackage, response.data.needNotified);
        return hasPaidTrialPack;
    } catch (error) {
        console.warn('[LaunchOrderGeneration] Failed to verify trial payment entitlement:', error);
        return null;
    }
}
export async function resumeLaunchOrderGenerationAfterLogin(expectedProjectId, order) {
    let openEntitlementModalWhenEmpty = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    const { isFreeUser: wasFreeUser } = useUserStore.getState();
    const { notifies } = useUserNotifyStore.getState();
    const verifiedHasPaidTrialPack = wasFreeUser ? await resolveHasPaidTrialPack() : !notifies[UserNotify.TrafficPackage];
    const { projectId, status } = useProjectStore.getState();
    const { isFreeUser, userPoints } = useUserStore.getState();
    const action = getLaunchOrderPostLoginAction({
        isCurrentProject: projectId === expectedProjectId,
        isCurrentRoute: getProjectIdFromUrl() === expectedProjectId,
        isLaunchOrderPending: Boolean(order) && status === ProjectStatus.PENDING,
        isFreeUser,
        hasPaidTrialPack: verifiedHasPaidTrialPack === true,
        userPoints
    });
    if (action === 'continue-generation') {
        continueLaunchOrderGeneration(order, expectedProjectId);
        return action;
    }
    if (openEntitlementModalWhenEmpty) {
        if (action === 'open-credit-purchase-modal') {
            openCreditPurchaseModal(CreditModalSource.SEND_MESSAGE);
        } else if (action === 'open-pricing-modal') {
            openLaunchOrderUpgradeModal();
        }
    }
    return action;
}
export async function resumePaidLaunchOrderGenerationAfterLogin(expectedProjectId, order) {
    const action = await resumeLaunchOrderGenerationAfterLogin(expectedProjectId, order);
    if (action === 'continue-generation') {
        Message.success(intl.get('payBeforeLogin.projectLinked'));
    }
    return action;
}
